export const myMixin = {
    data() {
        return {
            isAjax: false, //判断表单验证是否成功
            loading_t: false, //表格加载中
            loading: false, //按钮加载
            gradess: 0,
        }
    },
    created() {
        this.loading_t = true;
    },
    methods: {
        //验证手机号码格式是否正确
        validatePass: (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请填写手机号码'));
            } else {
                let reg = /^1[3456789]\d{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('手机号码格式不正确'));
                }

            }
        },
        //限制金额不能为负数
        validateMoney: (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入金额'));
            } else {
                let reg = /^(?!0+(?:.0+)?$)(?:[1-9]\d*|0)(?:.\d{1,2})?$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('金额不能为负数且只能保留两位小数'));
                }

            }
        },
        dialogClose(formName) {

            this.resetForm(formName);
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isAjax = true;
                } else {
                    this.isAjax = false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
}


// WEBPACK FOOTER //
// ./src/mixin.js